
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.0662 17.5156C12.9767 18.5801 13.4102 18.9662 14.0662 19.4221C15.6295 20.5085 16.6548 21.2134 18.6307 22.4809C20.6065 23.7484 20.9498 22.3415 21.0632 21.98C21.3326 21.1212 22.7881 12.2091 22.9466 10.8161C23.0641 9.78359 22.991 9.37598 22.6949 9.14265C22.3129 8.84173 21.5422 9.06368 20.7294 9.37601C19.5603 9.82525 8.26516 14.572 6.83892 15.2006C5.48878 15.7958 6.07912 16.2976 6.47967 16.4996C6.83892 16.6807 8.31709 17.1496 8.66982 17.2385C10.4763 17.6936 11.0223 17.3263 11.7793 16.8935C12.8705 16.2696 17.8144 12.9036 18.0574 12.7465C18.3004 12.5894 18.5791 12.4148 18.765 12.5921C18.9508 12.7693 18.7507 13.0155 18.599 13.1684C17.132 14.6475 15.1556 16.4512 14.0662 17.5156Z","fill":"currentColor"}})])
          )
        }
      }
    